import { useState, useCallback } from 'react';
import { useSocureBaseLogic } from '@Hooks/socure/useSocureBaseLogic';
import { useSendValidationMessage } from '@Hooks/api/useSendSocureValidationMessage';
import { useBoundStore } from '@Store/useBoundStore';
import { useModal } from '@Hooks/modalManager/useModal';
import { ModalTypes } from '@Hooks/modalManager/modal.types';
import { VerificationProcessCompletedModal } from './VerificationProcessCompletedModal';
import { actOnNonUseSocure } from './NonUsSocureAnalytics';

export const NonUsSocureLogicHook = () => {
  const [isSentSms, setIsSentSms] = useState(false);
  const { setModal } = useModal();
  const customerId = useBoundStore((state) => state.customer.customerId)!;

  const {
    refetch: sendValidationMessage,
    isPending,
    data: socureData,
  } = useSendValidationMessage(customerId);

  const {
    openResendOption,
    isSuccessNotificationVisible,
    setIsSuccessNotificationVisible,
    errorMessage,
    setErrorMessage,
    timeLeft,
    onSendSmsClick: baseSendSms,
    isLoadingSms,
  } = useSocureBaseLogic({
    resendDocVFn: sendValidationMessage,
    isSending: isPending,
  });

  const onSendSmsClick = useCallback(async () => {
    await baseSendSms();
    setIsSentSms(true);
    actOnNonUseSocure('Text Me The Link');
  }, [baseSendSms]);

  const handleFinishedVerification = () => {
    setModal({
      isActive: true,
      type: ModalTypes.CUSTOM,
      persistModal: true,
      customComponent: <VerificationProcessCompletedModal />,
      blur: true,
    });
  };

  return {
    onSendSmsClick,
    isSentSms,
    openResendOption,
    timeLeft,
    isLoading: isLoadingSms,
    errorMessage,
    setErrorMessage,
    handleFinishedVerification,
    socureQR: socureData?.qrCode,
    socureUrl: socureData?.url,
    isSuccessNotificationVisible,
    setIsSuccessNotificationVisible,
  };
};
